<template>
  <div class="loader-container w-full h-full flex items-center justify-center">
    <LpLoader
      class="text-primary-500"
      :ring-size="ringSize"
    />
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'medium',
    },
  },
  setup(props) {
    let ringSize;

    switch (props.size) {
      case 'small':
        ringSize = '15';
        break;
      case 'big':
        ringSize = '50';
        break;
      case 'medium':
      default:
        ringSize = '25';
        break;
    }

    return {
      ringSize,
    };
  },
};
</script>
